<div id="main-wrapper" class="app-layout">
<% if ( user ) { %>

  <div class="admin" data-id="admin">

    <!-- ===================== Sidebar ===================== -->
    <sidebar-nav></sidebar-nav>

    <!-- ===================== Main ===================== -->
    <div class="admin__main">

      <header class="topbar">
        <button class="iconbtn topbar__hamburger" data-id="hamburger" type="button" aria-label="<%= _lcs( 'Menü öffnen' ) %>">
          <i class="icon icon--menu"></i>
        </button>
        <button class="iconbtn topbar__railtoggle" data-id="rail-toggle" type="button" aria-label="<%= _lcs( 'Seitenleiste ein-/ausklappen' ) %>">
          <i class="icon icon--panel-left-close"></i>
        </button>

        <div class="topbar__heading">
          <h1 class="topbar__title"><%= _lcs( 'Übersicht' ) %></h1>
          <div class="topbar__sub"><%= _lcs( 'Plattform-Status auf einen Blick' ) %></div>
        </div>

        <button class="iconbtn iconbtn--badge" type="button" aria-label="<%= _lcs( 'Benachrichtigungen' ) %>">
          <i class="icon icon--bell"></i>
        </button>

        <user-menu></user-menu>
      </header>

      <!-- ===================== Content slot ===================== -->
      <main class="content">
        <section data-id="page-content" class="page-content"></section>
      </main>

    </div>

    <div class="scrim" data-id="scrim"></div>
  </div>

<% } %>
</div>
